import { render, staticRenderFns } from "./organCard.vue?vue&type=template&id=638ab883&scoped=true&"
import script from "./organCard.vue?vue&type=script&lang=js&"
export * from "./organCard.vue?vue&type=script&lang=js&"
import style0 from "./organCard.vue?vue&type=style&index=0&id=638ab883&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ab883",
  null
  
)

export default component.exports